import { cn } from '@latitude/token-utils';
import { footerVariants } from 'variants/footerVariants';

export const SheetFooter = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn(footerVariants, className)} {...props} />
);
SheetFooter.displayName = 'SheetFooter';
